import React, { useEffect, useState } from 'react';
import '../../styles/guest-design.css';

const KIOSK_KEY = 'guest_kiosk_mode';

/** Kiosk mode: lobby tablets open the app with ?kiosk=1 once; the flag
 *  persists so every later navigation stays full-screen. ?kiosk=0 clears. */
export function isKioskMode(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    const flag = params.get('kiosk');
    if (flag === '1') localStorage.setItem(KIOSK_KEY, '1');
    if (flag === '0') localStorage.removeItem(KIOSK_KEY);
    return localStorage.getItem(KIOSK_KEY) === '1';
  } catch {
    return false;
  }
}

interface GDShellProps {
  children: React.ReactNode;
}

/**
 * Standard-layout stage: phone frame centered on desktop, full screen on
 * mobile and kiosk. Every gd screen renders inside this frame.
 */
const GDShell: React.FC<GDShellProps> = ({ children }) => {
  const [kiosk, setKiosk] = useState(isKioskMode);

  useEffect(() => {
    setKiosk(isKioskMode());
  }, []);

  return (
    <div className={`gd-root${kiosk ? ' gd-kiosk' : ''}`}>
      <div className="gd-stage">
        <div className="gd-phone">{children}</div>
      </div>
    </div>
  );
};

export default GDShell;
